import owd from 'owd/owd';

export default class Menu extends owd.Component {
    init() {
        this.$element.find('a').each((index, item) => {
            $(item).attr('data-label', $(item).text());
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('menu', {
    component: Menu
});
